module.exports = __webpack_public_path__ + "media/payments/upgrade-plan-e31f68f1.png";